import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';

import styles from './ActionsPopup/ActionsPopup.module.scss';

const DeviceDetail = React.memo(({ device, items, children }) => {
  const [open, setOpen] = useState(false);

  const handleEditOpenPopup = () => {
    setOpen(true);
  };

  const handleEditClosePopup = () => {
    setOpen(false);
  };

  const listItems = [];
  items.forEach((item) => {
    if (item.modelId === device.modelId) {
      listItems.push(item);
    }
  });

  return (
    <>
      <Button className={styles.button_edit} onClick={handleEditOpenPopup}>
        {children}
      </Button>
      <Modal closeIcon size="tiny" open={open} onClose={handleEditClosePopup}>
        <div className={styles.detailWrapper}>
          <div className={styles.detailHeader}>{device.name}</div>
          <div className={styles.detailContent}>
            <ul className={styles.listItems}>
              {listItems.map((item) => (
                <li key={item.id}>
                  <div className={styles.label}>{item.name}</div>
                  <div className={styles.contentValue}>
                    <div className={styles.value}>
                      {device.status === 0 && !Number.isNaN(device.items?.[item.itemName] * 1)
                        ? (device.items?.[item.itemName] * 1).toLocaleString('en-GB', {
                            minimumFractionDigits: item.decimalPoint,
                            maximumFractionDigits: item.decimalPoint,
                          })
                        : '-'}
                    </div>
                    <div className={styles.unit}>{item.unitName}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
});

DeviceDetail.propTypes = {
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  device: PropTypes.objectOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default DeviceDetail;
